const pageData = {
  page: 1,
  limit: 10,
  total: 0,
};
export default { pageData };
